export { getResidentialGooglePredictions, getCommercialGooglePredictions } from './googleSearchPredictions';
